import React from "react";

import { dictionaryGet } from "../../../common/functions";
import { INSTALLER_CODE } from "../../../common/constants";
import { ICurrent } from "../../../store/user/types";
import { Route, Section } from "../../../types/maintenance";

import isUnderMaintenance from "../../../helpers/isUnderMaintenance";

import { Installer } from "../types/download";
import { DownloadCard } from "../common/DownloadCard";
import {
  download,
  downloadBIUtils,
  downloadBiManual,
  downloadBiUtilsManual,
} from "./downloadFunctions";

export const renderQlikHistory = (
  installers: Installer | null,
  dictionary: any
) => {
  if (
    installers != null &&
    installers.QLIK.legacy != null &&
    installers.QLIK.legacy.length > 0
  ) {
    return (
      <a className="qlik-history-link" href="#/download-qlik-history">
        {dictionaryGet(dictionary, "global.console.download.qlik_link")}
      </a>
    );
  }
};

export const renderCards = (
  installers: Installer | null,
  dictionary: any,
  current: ICurrent,
  thunkDispatch: any,
  setIsLoading: React.Dispatch<React.SetStateAction<Record<string, boolean>>>,
  routeUnderMaintenance: any,
  isLoading: Record<string, boolean>) => {
  const hideLabel = true;
  if (installers !== null) {
    return (
      <>
        <DownloadCard
          title="TS Enterprise BI 2019/2022"
          logoPath={process.env.PUBLIC_URL + "/images/installers/BI.png"}
          version={installers.BI.version}
          dictionary={dictionary}
          isLoading={isLoading.BI}
          onDownload={() =>
            download(
              INSTALLER_CODE.BI,
              installers,
              current,
              thunkDispatch,
              setIsLoading
            )
          }
          isMaintenance={isUnderMaintenance(
            routeUnderMaintenance,
            Route.Download,
            Section.BiApp
          )}
        />
        <DownloadCard
          title="BI Utilities"
          logoPath={
            process.env.PUBLIC_URL + "/images/installers/BI_utilities.png"
          }
          version={installers.BI.biUtilitiesVersion}
          dictionary={dictionary}
          isLoading={isLoading.BI_UTILITIES}
          onDownload={() => downloadBIUtils(current,setIsLoading)}
          isMaintenance={isUnderMaintenance(
            routeUnderMaintenance,
            Route.Download,
            Section.BiUtilities
          )}
        />
        <DownloadCard
          title={`${dictionaryGet(dictionary, "global.console.guide")} TS Enterprise BI 2019/2022`}
          logoPath={process.env.PUBLIC_URL + "/images/installers/BI_guide.png"}
          version={installers.BI.version}
          dictionary={dictionary}
          isLoading={isLoading.BI_MANUAL}
          onDownload={() => downloadBiManual(current)}
        />
        {!hideLabel && 
        <>
        <DownloadCard
          title={`${dictionaryGet(dictionary, "global.console.guide")} BI Utilities`}
          logoPath={process.env.PUBLIC_URL + "/images/installers/BI_utilities_guide.png"}
          version={installers.BI.biUtilitiesVersion}
          dictionary={dictionary}
          isLoading={isLoading.BI_UTILITIES_MANUAL}
          onDownload={() => downloadBiUtilsManual(current)}
        />
        <DownloadCard
          title={`${dictionaryGet(dictionary, "global.console.download.installation_guide")}`}
          logoPath={process.env.PUBLIC_URL + "/images/installers/BI_installation_guide.png"}
          version={installers.BI.biUtilitiesVersion}
          dictionary={dictionary}
          isLoading={isLoading.BI_INSTALLATION_GUIDE}
          onDownload={() => downloadBiUtilsManual(current)}
        />
        </>
      }
      </>
    );
  }
  return null;
};
